module.exports = __webpack_public_path__ + "static/img/bg-en.d3b99329.png";